var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = (cspNonceMeta == null ? void 0 : cspNonceMeta.nonce) || (cspNonceMeta == null ? void 0 : cspNonceMeta.getAttribute("nonce"));
    promise = Promise.allSettled(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
        }
        link.crossOrigin = "";
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  function handlePreloadError(err) {
    const e = new Event("vite:preloadError", {
      cancelable: true
    });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
let Island$1 = (_a = class extends HTMLElement {
  constructor() {
    super();
    this.ready = new Promise((resolve) => {
      this.readyResolve = resolve;
    });
  }
  // any parents of `el` that are <is-land> (with conditions)
  static getParents(el, stopAt = false) {
    let nodes = [];
    while (el) {
      if (el.matches && el.matches(_a.tagName)) {
        if (stopAt && el === stopAt) {
          break;
        }
        if (Conditions.hasConditions(el)) {
          nodes.push(el);
        }
      }
      el = el.parentNode;
    }
    return nodes;
  }
  static async ready(el, parents) {
    if (!parents) {
      parents = _a.getParents(el);
    }
    if (parents.length === 0) {
      return;
    }
    let imports = await Promise.all(parents.map((p) => p.wait()));
    if (imports.length) {
      return imports[0];
    }
  }
  forceFallback() {
    if (window.Island) {
      Object.assign(_a.fallback, window.Island.fallback);
    }
    for (let selector in _a.fallback) {
      let components = Array.from(this.querySelectorAll(selector)).reverse();
      for (let node of components) {
        if (!node.isConnected) {
          continue;
        }
        let parents = _a.getParents(node);
        if (parents.length === 1) {
          let p = _a.ready(node, parents);
          _a.fallback[selector](p, node, _a.prefix);
        }
      }
    }
  }
  wait() {
    return this.ready;
  }
  async connectedCallback() {
    if (Conditions.hasConditions(this)) {
      this.forceFallback();
    }
    await this.hydrate();
  }
  getTemplates() {
    return this.querySelectorAll(`template[${_a.attr.template}]`);
  }
  replaceTemplates(templates) {
    for (let node of templates) {
      if (_a.getParents(node, this).length > 0) {
        continue;
      }
      let value = node.getAttribute(_a.attr.template);
      if (value === "replace") {
        let children = Array.from(this.childNodes);
        for (let child of children) {
          this.removeChild(child);
        }
        this.appendChild(node.content);
        break;
      } else {
        let html = node.innerHTML;
        if (value === "once" && html) {
          if (_a.onceCache.has(html)) {
            node.remove();
            return;
          }
          _a.onceCache.set(html, true);
        }
        node.replaceWith(node.content);
      }
    }
  }
  async hydrate() {
    let conditions = [];
    if (this.parentNode) {
      conditions.push(_a.ready(this.parentNode));
    }
    let attrs = Conditions.getConditions(this);
    for (let condition in attrs) {
      if (Conditions.map[condition]) {
        conditions.push(Conditions.map[condition](attrs[condition], this));
      }
    }
    await Promise.all(conditions);
    this.replaceTemplates(this.getTemplates());
    for (let fn of _a.onReady.values()) {
      await fn.call(this, _a);
    }
    this.readyResolve();
    this.setAttribute(_a.attr.ready, "");
    this.querySelectorAll(`[${_a.attr.defer}]`).forEach((node) => node.removeAttribute(_a.attr.defer));
  }
}, __publicField(_a, "tagName", "is-land"), __publicField(_a, "prefix", "is-land--"), __publicField(_a, "attr", {
  template: "data-island",
  ready: "ready",
  defer: "defer-hydration"
}), __publicField(_a, "onceCache", /* @__PURE__ */ new Map()), __publicField(_a, "onReady", /* @__PURE__ */ new Map()), __publicField(_a, "fallback", {
  ":not(is-land,:defined,[defer-hydration])": (readyPromise, node, prefix) => {
    let cloned = document.createElement(prefix + node.localName);
    for (let attr of node.getAttributeNames()) {
      cloned.setAttribute(attr, node.getAttribute(attr));
    }
    let shadowroot = node.shadowRoot;
    if (!shadowroot) {
      let tmpl = node.querySelector(":scope > template:is([shadowrootmode], [shadowroot])");
      if (tmpl) {
        let mode = tmpl.getAttribute("shadowrootmode") || tmpl.getAttribute("shadowroot") || "closed";
        shadowroot = node.attachShadow({ mode });
        shadowroot.appendChild(tmpl.content.cloneNode(true));
      }
    }
    if (shadowroot) {
      cloned.attachShadow({ mode: shadowroot.mode }).append(...shadowroot.childNodes);
    }
    cloned.append(...node.childNodes);
    node.replaceWith(cloned);
    return readyPromise.then(() => {
      if (cloned.shadowRoot) {
        node.shadowRoot.append(...cloned.shadowRoot.childNodes);
      }
      node.append(...cloned.childNodes);
      cloned.replaceWith(node);
    });
  }
}), _a);
const _Conditions = class _Conditions {
  static hasConditions(node) {
    return Object.keys(_Conditions.getConditions(node)).length > 0;
  }
  static getConditions(node) {
    let map = {};
    for (let key of Object.keys(_Conditions.map)) {
      if (node.hasAttribute(`on:${key}`)) {
        map[key] = node.getAttribute(`on:${key}`);
      }
    }
    return map;
  }
  static visible(noop, el) {
    if (!("IntersectionObserver" in window)) {
      return;
    }
    return new Promise((resolve) => {
      let observer = new IntersectionObserver((entries) => {
        let [entry] = entries;
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          resolve();
        }
      });
      observer.observe(el);
    });
  }
  // Warning: on:idle is not very useful with other conditions as it may resolve long before.
  static idle() {
    let onload = new Promise((resolve) => {
      if (document.readyState !== "complete") {
        window.addEventListener("load", () => resolve(), { once: true });
      } else {
        resolve();
      }
    });
    if (!("requestIdleCallback" in window)) {
      return onload;
    }
    return Promise.all([
      new Promise((resolve) => {
        requestIdleCallback(() => {
          resolve();
        });
      }),
      onload
    ]);
  }
  static interaction(eventOverrides, el) {
    let events = ["click", "touchstart"];
    if (eventOverrides) {
      events = (eventOverrides || "").split(",").map((entry) => entry.trim());
    }
    return new Promise((resolve) => {
      function resolveFn(e) {
        resolve();
        for (let name of events) {
          el.removeEventListener(name, resolveFn);
        }
      }
      for (let name of events) {
        el.addEventListener(name, resolveFn, { once: true });
      }
    });
  }
  static media(query) {
    let mm = {
      matches: true
    };
    if (query && "matchMedia" in window) {
      mm = window.matchMedia(query);
    }
    if (mm.matches) {
      return;
    }
    return new Promise((resolve) => {
      mm.addListener((e) => {
        if (e.matches) {
          resolve();
        }
      });
    });
  }
  static saveData(expects) {
    if (!("connection" in navigator) || navigator.connection.saveData === (expects !== "false")) {
      return;
    }
    return new Promise(() => {
    });
  }
};
__publicField(_Conditions, "map", {
  visible: _Conditions.visible,
  idle: _Conditions.idle,
  interaction: _Conditions.interaction,
  media: _Conditions.media,
  "save-data": _Conditions.saveData
});
let Conditions = _Conditions;
if ("customElements" in window) {
  window.customElements.define(Island$1.tagName, Island$1);
  window.Island = Island$1;
}
Island$1.ready;
class IslandAutoinit {
}
__publicField(IslandAutoinit, "attr", {
  autoInitType: "autoinit",
  import: "import"
});
__publicField(IslandAutoinit, "types", {
  "petite-vue": function(lib) {
    lib.createApp().mount(this);
  },
  "vue": function(lib) {
    lib.createApp().mount(this);
  },
  "svelte": function(lib) {
    new lib.default({ target: this });
  },
  "svelte-ssr": function(lib) {
    new lib.default({ target: this, hydrate: true });
  },
  "preact": function(lib) {
    lib.default(this);
  }
});
Island.onReady.set("import-autoinit", async function(Island2) {
  let mod;
  let importScript = this.getAttribute(IslandAutoinit.attr.import);
  if (importScript) {
    mod = await import(importScript);
  }
  if (mod) {
    let fn = IslandAutoinit.types[this.getAttribute(IslandAutoinit.attr.autoInitType) || importScript];
    if (fn) {
      await fn.call(this, mod);
    }
  }
});
function getFocusableElements(container) {
  const elements = Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
  return elements.filter(
    (element) => !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length)
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
function initDisclosureWidgets(summaries2) {
  summaries2.forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );
    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
}
const summaries = document.querySelectorAll('[id^="Details-"] summary');
initDisclosureWidgets(summaries);
window.islands = /* @__PURE__ */ Object.assign({ "/frontend/islands/AnnouncementBar.js": () => __vitePreload(() => import("islands/AnnouncementBar"), true ? [] : void 0, import.meta.url), "/frontend/islands/CollectionFaq.js": () => __vitePreload(() => import("islands/CollectionFaq"), true ? [] : void 0, import.meta.url), "/frontend/islands/DesktopNavigation.js": () => __vitePreload(() => import("islands/DesktopNavigation"), true ? [] : void 0, import.meta.url), "/frontend/islands/Footer.js": () => __vitePreload(() => import("islands/Footer"), true ? [] : void 0, import.meta.url), "/frontend/islands/HomeBestsellers.js": () => __vitePreload(() => import("islands/HomeBestsellers"), true ? [] : void 0, import.meta.url), "/frontend/islands/HomeCommunityReviews.js": () => __vitePreload(() => import("islands/HomeCommunityReviews"), true ? [] : void 0, import.meta.url), "/frontend/islands/HomeTopBrands.js": () => __vitePreload(() => import("islands/HomeTopBrands"), true ? [] : void 0, import.meta.url), "/frontend/islands/HomeVehicleShop.js": () => __vitePreload(() => import("islands/HomeVehicleShop"), true ? [] : void 0, import.meta.url), "/frontend/islands/MobileNavigation.js": () => __vitePreload(() => import("islands/MobileNavigation"), true ? [] : void 0, import.meta.url), "/frontend/islands/MobileSearch.js": () => __vitePreload(() => import("islands/MobileSearch"), true ? [] : void 0, import.meta.url), "/frontend/islands/ProductSlider.js": () => __vitePreload(() => import("islands/ProductSlider"), true ? [] : void 0, import.meta.url), "/frontend/islands/VehicleSection.js": () => __vitePreload(() => import("islands/VehicleSection"), true ? [] : void 0, import.meta.url), "/frontend/islands/addon-promo-badges.js": () => __vitePreload(() => import("islands/addon-promo-badges"), true ? [] : void 0, import.meta.url), "/frontend/islands/bundle-cards-slider.js": () => __vitePreload(() => import("islands/bundle-cards-slider"), true ? [] : void 0, import.meta.url), "/frontend/islands/cart-drawer-items.js": () => __vitePreload(() => import("islands/cart-drawer-items"), true ? [] : void 0, import.meta.url), "/frontend/islands/cart-drawer.js": () => __vitePreload(() => import("islands/cart-drawer"), true ? [] : void 0, import.meta.url), "/frontend/islands/cart-items.js": () => __vitePreload(() => import("islands/cart-items"), true ? [] : void 0, import.meta.url), "/frontend/islands/cart-note.js": () => __vitePreload(() => import("islands/cart-note"), true ? [] : void 0, import.meta.url), "/frontend/islands/cart-remove-button.js": () => __vitePreload(() => import("islands/cart-remove-button"), true ? [] : void 0, import.meta.url), "/frontend/islands/collection-filters.js": () => __vitePreload(() => import("islands/collection-filters"), true ? [] : void 0, import.meta.url), "/frontend/islands/custom-kit-configurator.js": () => __vitePreload(() => import("islands/custom-kit-configurator"), true ? [] : void 0, import.meta.url), "/frontend/islands/details-disclosure.js": () => __vitePreload(() => import("islands/details-disclosure"), true ? [] : void 0, import.meta.url), "/frontend/islands/details-modal.js": () => __vitePreload(() => import("islands/details-modal"), true ? [] : void 0, import.meta.url), "/frontend/islands/front-shock-assembly-addon.js": () => __vitePreload(() => import("islands/front-shock-assembly-addon"), true ? [] : void 0, import.meta.url), "/frontend/islands/front-shock-assembly-media.js": () => __vitePreload(() => import("islands/front-shock-assembly-media"), true ? [] : void 0, import.meta.url), "/frontend/islands/header-drawer.js": () => __vitePreload(() => import("islands/header-drawer"), true ? [] : void 0, import.meta.url), "/frontend/islands/lift-kit-pdp-section-nav.js": () => __vitePreload(() => import("islands/lift-kit-pdp-section-nav"), true ? [] : void 0, import.meta.url), "/frontend/islands/lift-kit-sticky-atc.js": () => __vitePreload(() => import("islands/lift-kit-sticky-atc"), true ? [] : void 0, import.meta.url), "/frontend/islands/lift-kit-vehicle-preview.js": () => __vitePreload(() => import("islands/lift-kit-vehicle-preview"), true ? [] : void 0, import.meta.url), "/frontend/islands/localization-form.js": () => __vitePreload(() => import("islands/localization-form"), true ? [] : void 0, import.meta.url), "/frontend/islands/more-addons-widget.js": () => __vitePreload(() => import("islands/more-addons-widget"), true ? [] : void 0, import.meta.url), "/frontend/islands/partner-marquee.js": () => __vitePreload(() => import("islands/partner-marquee"), true ? [] : void 0, import.meta.url), "/frontend/islands/password-modal.js": () => __vitePreload(() => import("islands/password-modal"), true ? [] : void 0, import.meta.url), "/frontend/islands/pdp-uca-addons.js": () => __vitePreload(() => import("islands/pdp-uca-addons"), true ? [] : void 0, import.meta.url), "/frontend/islands/product-form.js": () => __vitePreload(() => import("islands/product-form"), true ? [] : void 0, import.meta.url), "/frontend/islands/product-recommendations.js": () => __vitePreload(() => import("islands/product-recommendations"), true ? [] : void 0, import.meta.url), "/frontend/islands/product-tabs-optimized.js": () => __vitePreload(() => Promise.resolve().then(() => productTabsOptimized), true ? void 0 : void 0, import.meta.url), "/frontend/islands/product-tabs.js": () => __vitePreload(() => import("islands/product-tabs"), true ? [] : void 0, import.meta.url), "/frontend/islands/promo-box-lift-kit.js": () => __vitePreload(() => import("islands/promo-box-lift-kit"), true ? [] : void 0, import.meta.url), "/frontend/islands/promo-box.js": () => __vitePreload(() => import("islands/promo-box"), true ? [] : void 0, import.meta.url), "/frontend/islands/quantity-input.js": () => __vitePreload(() => import("islands/quantity-input"), true ? [] : void 0, import.meta.url), "/frontend/islands/reviews-slider.js": () => __vitePreload(() => import("islands/reviews-slider"), true ? [] : void 0, import.meta.url), "/frontend/islands/sticky-header.js": () => __vitePreload(() => import("islands/sticky-header"), true ? [] : void 0, import.meta.url), "/frontend/islands/suspension-helper.js": () => __vitePreload(() => import("islands/suspension-helper"), true ? [] : void 0, import.meta.url), "/frontend/islands/tire-widget.js": () => __vitePreload(() => import("islands/tire-widget"), true ? [] : void 0, import.meta.url), "/frontend/islands/variant-radios.js": () => __vitePreload(() => import("islands/variant-radios"), true ? [] : void 0, import.meta.url), "/frontend/islands/variant-selects.js": () => __vitePreload(() => import("islands/variant-selects"), true ? [] : void 0, import.meta.url) });
const garageRoots = document.querySelectorAll("#cm-single-garage, #cm-mobile-single-garage");
const syncGarageOpenState = (root) => {
  const expandedControl = root.querySelector('[aria-expanded="true"]');
  const dropdown = root.querySelector(".cm_garageDropdown, .cm_vehicle-widget__dialog, .dialog-container");
  const dropdownIsVisible = dropdown && !dropdown.hidden && window.getComputedStyle(dropdown).display !== "none" && window.getComputedStyle(dropdown).visibility !== "hidden";
  root.classList.toggle("is-garage-open", Boolean(expandedControl || dropdownIsVisible));
};
garageRoots.forEach((root) => {
  syncGarageOpenState(root);
  new MutationObserver(() => {
    syncGarageOpenState(root);
  }).observe(root, { attributes: true, childList: true, subtree: true });
  root.addEventListener("click", () => {
    window.setTimeout(() => syncGarageOpenState(root), 0);
    window.setTimeout(() => syncGarageOpenState(root), 150);
  });
});
const productTabsOptimized = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  removeTrapFocus,
  trapFocus
};
